<div class="content-block">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <div class="card">
        <div class="card2">
          <img [src]="companyLogo" style="width: 50px; height: 50px;" alt="">
          <h3>Create a SmartAccuPay Account </h3>

          <button mat-button class="link-button" (click)="openLogin()" target="_blank"><span>{{'Already a
          User' | translate}}</span>
        {{'Login' | translate}}</button>
        <div>
          @if (!isTrial) {
            <div>
              <mat-horizontal-stepper [linear]="true" (selectionChange)="onStepChange($event)" #stepper>
                <!-- Step 1: Registration Form -->
                <mat-step [stepControl]="registerForm">
                  <form class="register-form m-4" [formGroup]="registerForm">
                    <ng-template matStepLabel>{{ 'Form Details' | translate }}</ng-template>
                    <div class="row">
                      <div class="col">
                        <mat-form-field class="example-full-width" appearance="outline">
                          <mat-label>{{'SUPERADMIN.CLIENT.FORM.COMPANY_INFO.COMPANY_NAME' |
                          translate}}</mat-label>
                          <input matInput formControlName="companyname" required>
                          @if (registerForm.get('companyname')?.hasError('customError')) {
                            <mat-error
                              >
                              {{
                              registerForm.get('companyname')?.getError('customError')?.message
                              }}
                            </mat-error>
                          }
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <mat-form-field class="example-full-width" appearance="outline">
                          <mat-label>{{'SUPERADMIN.CLIENT.FORM.CONTACT_PERSON_INFO.FIRST_NAME'
                            |
                          translate}}</mat-label>
                          <input matInput formControlName="conatactpersonfirstname" required>
                        </mat-form-field>
                      </div>
                      <div class="col">
                        <mat-form-field class="example-full-width" appearance="outline">
                          <mat-label>{{'SUPERADMIN.CLIENT.FORM.CONTACT_PERSON_INFO.LAST_NAME'
                            |
                          translate}}</mat-label>
                          <input matInput formControlName="conatactpersonlastname" required>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <mat-form-field class="example-full-width" appearance="outline">
                          <mat-label>{{ 'SUPERADMIN.CLIENT.FORM.COMPANY_INFO.EMAIL' |
                          translate }}</mat-label>
                          <input matInput formControlName="companyemail" required>
                          @if (registerForm.get('companyemail')?.hasError('customError')) {
                            <mat-error
                              >
                              {{ registerForm.get('companyemail')?.getError('customError') }}
                            </mat-error>
                          }
                        </mat-form-field>
                      </div>
                      <div class="col">
                        <mat-form-field class="example-full-width" appearance="outline">
                          <mat-label>{{'SUPERADMIN.CLIENT.FORM.COMPANY_INFO.PHONE' |
                          translate}}</mat-label>
                          <input matInput formControlName="companyphone" required
                            mask="(000) 000-0000" maxlength="14"
                            (keypress)="validateNumericInput($event)">
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <mat-form-field class="example-full-width" appearance="outline">
                          <mat-label>{{'SUPERADMIN.CLIENT.FORM.COMPANY_INFO.ACTIVE_SINCE'
                          | translate}}</mat-label>
                          <mat-select formControlName="companyactivesince" required>
                            @for (value of range; track value) {
                              <mat-option [value]="value">
                                {{ value }}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div class="col">
                        <mat-form-field class="example-full-width" appearance="outline">
                          <mat-label>{{ 'SUPERADMIN.CLIENT.FORM.COMPANY_INFO.EIN' | translate
                          }}</mat-label>
                          <input matInput formControlName="companyein" mask="00-0000000"
                            maxlength="10"
                            onkeypress="return String.fromCharCode(event.charCode).match(/[^0-9]/g) === null">
                            @if (registerForm.get('companyein')?.hasError('customError')) {
                              <mat-error
                                >
                              {{ registerForm.get('companyein')?.getError('customError') }}
                            </mat-error>
                          }
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2">
                        <div id="geocoder-container" class="geocoder-container"></div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <mat-form-field class="example-full-width" appearance="outline">
                          <mat-label>{{'SUPERADMIN.CLIENT.FORM.ADDRESS_INFO.ADDRESS' |
                          translate}}</mat-label>
                          <input matInput formControlName="companyaddress" required>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <mat-form-field class="example-full-width" appearance="outline">
                          <mat-label>{{'SUPERADMIN.CLIENT.FORM.ADDRESS_INFO.CITY' |
                          translate}}</mat-label>
                          <input matInput formControlName="companyaddresscity" required>
                        </mat-form-field>
                      </div>
                      <div class="col">
                        <mat-form-field class="example-full-width" appearance="outline">
                          <mat-label>{{'SUPERADMIN.CLIENT.FORM.ADDRESS_INFO.STATE' |
                          translate}}</mat-label>
                          <input matInput formControlName="companyaddressstate" required>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <mat-form-field class="example-full-width" appearance="outline">
                          <mat-label>{{'SUPERADMIN.CLIENT.FORM.ADDRESS_INFO.ZIP_CODE' |
                          translate}}</mat-label>
                          <input matInput formControlName="companyaddresszip" required
                            maxlength="5"
                            onkeypress="return String.fromCharCode(event.charCode).match(/[^0-9]/g) === null">
                          </mat-form-field>
                        </div>
                      </div>
                      @if (areClientFieldsFilled()) {
                        <div class="row">
                          <mat-slide-toggle formControlName="auto_fill_billing"
                            (change)="toggleBillingAddress($event)">
                          {{'SUPERADMIN.CLIENT.FORM.TOGGLE_ADDRESS' | translate}}
                        </mat-slide-toggle>
                      </div>
                    }
                    <div class="row mt-4">
                      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2">
                        <mat-form-field class="example-full-width" appearance="outline">
                          <mat-label>{{'SUPERADMIN.CLIENT.FORM.BILLING_INFO.ADDRESS' |
                          translate}}</mat-label>
                          <input matInput formControlName="billingpersonaddress" />
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col" style="font-size: 12px;">
                        <mat-form-field class="example-full-width" appearance="outline">
                          <mat-label>{{'SUPERADMIN.CLIENT.FORM.BILLING_INFO.CITY' |
                          translate}}</mat-label>
                          <input matInput formControlName="billingpersoncity"
                            style="text-transform:capitalize !important;">
                        </mat-form-field>
                      </div>
                      <div class="col">
                        <mat-form-field class="example-full-width" appearance="outline">
                          <mat-label>{{'SUPERADMIN.CLIENT.FORM.BILLING_INFO.STATE' |
                          translate}}</mat-label>
                          <input matInput formControlName="billingpersonstate"
                            onkeypress="return String.fromCharCode(event.charCode).match(/[^A-Za-z ]/g) === null" />
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col" style="font-size: 12px;">
                        <mat-form-field class="example-full-width" appearance="outline">
                          <mat-label>{{ 'SUPERADMIN.CLIENT.FORM.BILLING_INFO.ZIP_CODE' |
                            translate
                          }}</mat-label>
                          <input matInput formControlName="billingpersonzipcode"
                            style="text-transform:capitalize !important;" [maxlength]="max"
                            [minlength]="min"
                            onkeypress="return String.fromCharCode(event.charCode).match(/[^0-9]/g) === null">
                          </mat-form-field>
                        </div>
                      </div>
                      <div class="actions">
                        <button mat-raised-button color="primary" class="width-set-2"
                          matStepperNext>{{ 'Next' | translate
                        }}</button>
                      </div>
                    </form>
                  </mat-step>
                  <!-- Step 2: Payment Details -->
                  <mat-step>
                    <ng-template matStepLabel>{{ 'Payment Details' | translate }}</ng-template>
                    <div class="row">
                      <div class="payment-form">
                        <h2>{{ 'SmartAccuPay Pricing Info' | translate }}</h2>
                        <div class="invoice">
                          <div class="invoice-row">
                            <p><strong>{{ 'Plan Name' | translate }}:</strong></p>
                            <p>{{ planData?.name }}</p>
                          </div>
                          <div class="invoice-row">
                            <p><strong>{{ 'Description' | translate }}:</strong></p>
                            <p>{{ planData?.description }}</p>
                          </div>
                          <div class="invoice-row">
                            <p><strong>{{ 'Price' | translate }}:</strong></p>
                            <p>${{ price }}</p>
                          </div>
                          <div class="invoice-row">
                            <p><strong>{{ 'Discount' | translate }}:</strong></p>
                            <p>$0</p>
                          </div>
                          <div class="invoice-row total-row">
                            <p><strong>{{ 'Total' | translate }}:</strong></p>
                            <p>${{ price }}</p>
                          </div>
                        </div>
                        <div class="m-2">
                          <h2>{{ 'Billing Information' | translate }}</h2>
                          <div class="invoice-row">
                            <p><strong>{{ 'Billing Type' | translate }}:</strong></p>
                            <p>{{ planData?.payment_method === 'one-off' ? 'One-time Payment' :
                              'Recurring Payment'
                            }}</p>
                          </div>
                          <div id="card-element"></div>
                        </div>
                        <div>
                          <h2>{{ 'Terms & Privacy' | translate }}</h2>
                          <div>
                            <!-- Terms and Conditions Checkbox -->
                            <mat-checkbox [(ngModel)]="isTermsChecked"
                              (click)="openDialog('terms', $event)">
                            {{ 'I agree to the' | translate }}
                          </mat-checkbox>
                          <a (click)="openDialog('terms', $event)" class="terms-link">
                            {{ 'Terms and Conditions' | translate }}
                          </a>.
                        </div>
                        <!-- Privacy Policy Checkbox -->
                        <mat-checkbox [(ngModel)]="isPrivacyChecked"
                          (click)="openDialog('privacy', $event)">
                          {{ 'I agree to the' | translate }}
                        </mat-checkbox>
                        <a (click)="openDialog('privacy', $event)" class="privacy-link">
                          {{ 'Privacy Policy' | translate }}
                        </a>.
                      </div>
                      <button (click)="createPaymentIntent(price)"
                        [disabled]="!isTermsChecked || !isPrivacyChecked">
                        {{ 'Pay' | translate }} ${{ price}}
                      </button>
                    </div>
                  </div>
                  <div class="actions m-3">
                    <button mat-raised-button color="primary" class="width-set-2"
                      matStepperPrevious>
                      {{ 'Previous' | translate }}
                    </button>
                  </div>
                </mat-step>
                <!-- Step 3: Finished -->
                <mat-step>
                  <ng-template matStepLabel>{{ 'Finished' | translate }}</ng-template>
                  @if (is_show) {
                    <div class="row">
                      <app-payment-status-form></app-payment-status-form>
                    </div>
                  }
                </mat-step>
              </mat-horizontal-stepper>
            </div>
          }

          @if (isTrial) {
            <div>
              <form class="register-form m-4" [formGroup]="trialRegisterForm">
                <ng-template matStepLabel>{{ 'Form Details' | translate }}</ng-template>
                <div class="row">
                  <div class="col">
                    <mat-form-field class="example-full-width" appearance="outline">
                      <mat-label>{{'SUPERADMIN.CLIENT.FORM.COMPANY_INFO.COMPANY_NAME' |
                      translate}}</mat-label>
                      <input matInput formControlName="companyname" required>
                      @if (registerForm.get('companyname')?.hasError('customError')) {
                        <mat-error>
                          {{
                          registerForm.get('companyname')?.getError('customError')?.message
                          }}
                        </mat-error>
                      }
                    </mat-form-field>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <mat-form-field class="example-full-width" appearance="outline">
                      <mat-label>{{'SUPERADMIN.CLIENT.FORM.CONTACT_PERSON_INFO.FIRST_NAME' |
                      translate}}</mat-label>
                      <input matInput formControlName="conatactpersonfirstname" required>
                    </mat-form-field>
                  </div>
                  <div class="col">
                    <mat-form-field class="example-full-width" appearance="outline">
                      <mat-label>{{'SUPERADMIN.CLIENT.FORM.CONTACT_PERSON_INFO.LAST_NAME' |
                      translate}}</mat-label>
                      <input matInput formControlName="conatactpersonlastname" required>
                    </mat-form-field>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <mat-form-field class="example-full-width" appearance="outline">
                      <mat-label>{{ 'SUPERADMIN.CLIENT.FORM.COMPANY_INFO.EMAIL' |
                      translate }}</mat-label>
                      <input matInput formControlName="companyemail" required>
                      @if (registerForm.get('companyemail')?.hasError('customError')) {
                        <mat-error
                          >
                          {{ registerForm.get('companyemail')?.getError('customError') }}
                        </mat-error>
                      }
                    </mat-form-field>
                  </div>
                  <div class="col">
                    <mat-form-field class="example-full-width" appearance="outline">
                      <mat-label>{{'SUPERADMIN.CLIENT.FORM.COMPANY_INFO.PHONE' |
                      translate}}</mat-label>
                      <input matInput formControlName="companyphone" required
                        mask="(000) 000-0000" maxlength="14"
                        (keypress)="validateNumericInput($event)">
                    </mat-form-field>
                  </div>
                </div>
                <div class="actions">
                  <button mat-raised-button color="primary" class="width-set-2"
                  (click)="saveTrialRegister()">{{ 'Save' | translate}}</button>
                </div>
              </form>
            </div>
          }

        </div>
      </div>
    </div>
  </div>
</div>
</div>